/**
 * 日期格式化工具函数
 * @param {number|string} timestamp - 时间戳（支持10位秒级/13位毫秒级）
 * @param {string} [formatType] - 格式类型，传 'full' 时返回年月日时分秒，否则仅返回年月日
 * @returns {string} 格式化后的日期字符串（YYYY-MM-DD 或 YYYY-MM-DD HH:mm:ss），无效日期返回'--'
 */
export function formatDate(timestamp, formatType) {
  if (!timestamp) return "--"; // 修复原逻辑：未处理 timestamp 为 null/undefined 的情况
console.log('timestamp',typeof timestamp)
  let ts;
  if (typeof timestamp === "object" || typeof timestamp === "string") {
    ts = new Date(timestamp).getTime();
    if (isNaN(ts)) return "--";
  } else {
    ts = Number(timestamp) * (timestamp < 10000000000 ? 1000 : 1);
  }

  const date = new Date(ts);
  if (isNaN(date.getTime())) return "--";

  const year = date.getFullYear();
  console.log(year);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  // 新增时间格式化逻辑
  if (formatType === "all") {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  return `${year}-${month}-${day}`;
}

/**
 * 判断对象中的值（指定字段或全部字段）是否都为空（null / undefined）
 * @param {Object} obj - 要检查的对象
 * @param {Array<string>} [keys] - 可选字段名数组，不传时检查所有 key
 * @returns {boolean}
 */
export function areAllFieldsEmpty(obj, keys) {
  if (!obj || typeof obj !== "object") return {};

  const targetKeys =
    Array.isArray(keys) && keys.length > 0 ? keys : Object.keys(obj);

  return targetKeys.every((key) => obj[key] === null || obj[key] === undefined)
    ? {}
    : obj;
}

// 身份证脱敏处理函数
export function formatOwnerNum(ownerNum) {
  if (!ownerNum) return "";
  if (typeof ownerNum !== "string" && typeof ownerNum !== "number") {
    console.error("ownerNum 类型错误");
    return null;
  }
  // 示例：假设身份证号为 18 位
  const masked = ownerNum
    .toString()
    .replace(
      /^(.{2})(.*)(.{2})$/,
      "$1" + "*".repeat(ownerNum.length - 4) + "$3"
    );
  return masked;
}
//电话号码脱敏处理函数
export function formatPhoneNum(phoneNum) {
  if (!phoneNum) return "";
  if (typeof phoneNum !== "string" && typeof phoneNum !== "number") {
    console.error("phoneNum 类型错误");
    return null;
  }
  // 示例：假设手机号为 11 位
  const masked = phoneNum
    .toString()
    .replace(/(\d{3})(\d{4})(\d{4})/, "$1****$3");
  return masked;
}

// 根据类型返回对应的颜色和边框
export function immuneDomesticType(type) {
  switch (type) {
    case 2:
      return {
        name: "进口",
        color: { color: "#FFD157", border: "1px solid #FFD157" },
      };
    case 1:
      return {
        name: "国产",
        color: { color: "#5CD1D7", border: "1px solid #5CD1D7" },
      };
    default:
      return {};
  }
}
//犬证状态判断
export function changeStatusColor(status) {
  switch (status) {
    case 1:
      return { color: "#FF6A2A", name: "审核中" };
    case 2:
      return { color: "#1E92F0", name: "生效中" };
    case 3:
      return { color: "#FF6A2A", name: "审核不通过" };
    case 4:
      return { color: "#FF6A2A", name: "已过期" };
    default:
      return { color: "", name: "" };
  }
}
// 宠物是否绝育
export function petSterilizationFilter(val) {
  let p = {
    0: "未绝育",
    1: "已绝育",
  };
  return p[val] || "";
}

// 卡片顶部按钮判断
export function changeTopBtnText(val) {
  switch (val) {
    case 1:
      return "撤回审核";
    case 2:
      return "更新犬证信息";
    case 3:
    case 4:
      return "重新上传";
    default:
      return "";
  }
}
export function changeTopImmnuityBtnText(val) {
  switch (val) {
    case 1:
      return "撤回审核";
    case 2:
      return "更新免疫证明信息";
    case 3:
    case 4:
      return "重新上传";
    default:
      return "";
  }
}
/**
 * 判断宠物类型
 * @param {*} petType
 * @returns
 */
export function filterPetType(petType) {
  switch (petType) {
    case 0:
      return "犬";
    case 1:
      return "猫";
    case 3:
      return "通用";
    default:
      return "";
  }
}
/**
 * 判断疫苗类型
 * @param {*} immune
 * @returns
 */
export function filterImmune(immune, immuneOption) {
  const item = immuneOption.find((opt) => opt.id === immune);
  return item ? item.immuneTypeName : "-";
}

// 递归展平所有子项到一个数组中
export function flattenChildren(arr) {
  let result = [];
  if (!Array.isArray(arr)) return result;
  arr.forEach((item) => {
    result.push(item);
    // 支持 children 或 child 字段
    const children = item.children || item.child;
    if (children && children.length > 0) {
      result = result.concat(this.flattenChildren(children));
    }
  });
  return result;
}

/**
 * 手机号格式化函数
 * @param {*} value
 * @returns
 */
export function formatPhone(value) {
  // 只允许输入数字
  return value.replace(/\D/g, "");
}
/**
 * 输入框纯汉字格式化函数
 * @param {*} value
 * @returns
 */
export function formatChinese(value) {
  // 只保留汉字并限制长度为10
  return value.replace(/[^\u4e00-\u9fa5]/g, "").substring(0, 10);
}
/**
 * 身份证号格式化函数
 * @param {*} value
 * @returns
 */
export function formatIdCard(value) {
  // 转换为大写
  let formattedValue = value.toUpperCase();
  // 前17位只允许数字
  let result = formattedValue.substring(0, 17).replace(/\D/g, "");
  // 第18位允许数字或X
  if (formattedValue.length > 17) {
    const lastChar = formattedValue.charAt(17);
    if (lastChar === "X" || /\d/.test(lastChar)) {
      result += lastChar;
    }
  }
  return result;
}

// 计算时间 获取结束时间
/**
 *
 * @param {*} newTime   //开始时间
 * @param {*} nextDate  //天数（int），距离开始时间的天数
 * @returns
 */
export function getTimeDate(newTime, nextDate) {
  if (newTime && nextDate) {
    const endDate = 24 * 3600 * 1000 * nextDate;

    const startDate = new Date(newTime).getTime();

    const newData = new Date(endDate + startDate)
      .toJSON()
      .substr(0, 10)
      .replace("T", " ");
    return newData;
  }
}
